/** What tapping "Make this your Banker" (or the active banker's own button) should do next. */
export type BankerToggleAction =
  | 'remove' // tapping the currently-active banker's own button
  | 'set' // no banker chosen yet this gameweek
  | 'armSwitch' // a different fixture is already the banker — requires confirmation first
  | 'noop' // deadline has passed, nothing is actionable

/** Pure decision for what a banker-button tap should do, given the current pick and deadline state.
 */
export function resolveBankerToggle(
  bankerGameId: string | null,
  gameId: string,
  isDeadlinePassed: boolean
): BankerToggleAction {
  if (isDeadlinePassed) return 'noop'
  if (bankerGameId === gameId) return 'remove'
  if (bankerGameId === null) return 'set'
  return 'armSwitch'
}
